var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "equipTable",
        attrs: {
          title: "설비 목록",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          filtering: false,
          columnSetting: false,
          usePaging: false,
          gridHeight: _vm.grid.height,
          rowKey: "equipmentCd",
        },
        on: { linkClick: _vm.linkClick },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }